import React, { useState } from "react";
import styles from "./Student.module.css";
import { Text, Image, ToggleButton, TagsInput } from ".."
import { capitalizeHead } from "../../../helpers/stringHelpers";
import { getAvgGrade } from "../../../helpers/arrayHelpers";
import cx from "classnames";

const Student = ( { searchTagValue, picUrl, firstName, lastName, details, grades } ) =>
{
    const fullName = ( `${firstName.toString()}\u00A0${lastName.toString()}` ).toUpperCase();

    const avgGrade = getAvgGrade(grades);

    const [isExpanded, setExpandState] = useState(false);
    const toggle = () => setExpandState(o => !o);

    const [tags, setTags] = useState([]);

    const addTags = event => {
        if (event.key === "Enter" && event.target.value !== "")
        {
            setTags([...tags, event.target.value]);
            event.target.value = "";
        }
    };

    //pass searchTagValue to child from Home
    //use this value to show, or hide elements
    //to show an element, check if searchTagValue is empty string

    const isVisible = () =>
    {
        if( searchTagValue === "" )
        {
            return true;
        } else if ( tags.find( a => a.toLowerCase().includes( searchTagValue.toLowerCase() ) ) )
        {
            return true;
        } else 
        {
            return false;
        }
    }

    return (
        <div className={ cx( styles.root, ( isVisible() ? styles["show"] : styles["hide"] ) )}>

            <Image source={picUrl} alt={fullName} width="130" height="130" ></Image>

            <div className={styles.contents}>
                <Text type="h1">{fullName}</Text>
                <ul className={styles.ul}>

                    {
                        Object.entries(details).map( ( [key, value] ) =>
                        {
                            return <li className={ styles.li }><Text>{ capitalizeHead(key) }: {value.toString()}</Text></li>
                        })
                    }

                    <li className={ styles.li }><Text>Average: {avgGrade}%</Text></li>

                    {
                        isExpanded ? (
                            Object.entries(grades).map( ( [key, value] ) =>
                            {
                                return <li className={ styles.li }><Text>Test{parseInt(key)+1}: {value.toString()}</Text></li>
                            })
                        ) : (<></>)
                        
                    }

                </ul>

                <div className="tags-input">
                    <ul className={styles.tagList}>
                        {tags.map((tag, index) => (
                            <li className={styles.tag} key={index}>
                                {tag}
                            </li>
                        ))}
                    </ul>
                </div>

                <TagsInput addTags={addTags} placeholder="Add Tag"></TagsInput>

            </div>
            
            <ToggleButton onClick={toggle} status={isExpanded}></ToggleButton>

        </div>

    )
}

Student.defaultProps = {};

export default Student;